import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, { label: "Arena Cycles" }, {
    default: _withCtx(() => [
      _createVNode(_component_app_table, {
        columns: _ctx.table.columns,
        rows: _ctx.list,
        total: _ctx.total,
        offset: _ctx.query.offset,
        limit: _ctx.query.limit,
        actions: _ctx.table.actions,
        onRefreshData: _ctx.fetchList
      }, null, 8, ["columns", "rows", "total", "offset", "limit", "actions", "onRefreshData"])
    ]),
    _: 1
  }))
}